import SidebarStandard from '../../components/sidebars/SidebarStandard.vue';

export default {
  computed: {
    sidebarContent() {
      return {
        title: {
          description: 'Document Registry',
          icon: 'mdi-flask-outline',
          link: 'ServiceAgreementList',
        },
        items: [
          {
            title: 'Service Agreement',
            icon: 'mdi-file-sign',
            link: 'service-agreement.list',
          },
          {
            title: 'Permits',
            icon: 'mdi-file-document-outline',
            link: 'permit.list',
          },
          {
            title: 'MTA Document',
            icon: 'mdi-file-document',
            link: 'mutual-transfer-agreement.list',
          },
        ],
      };
    },
  },
  components: {
    SidebarStandard,
  },
};
